import { combineReducers } from "redux";

import products from './productReducers'
import auth from './authReducers'

export default combineReducers({ products, auth })